module.exports = __webpack_public_path__ + "img/pic_poza-domem.ecd64477.svg";